var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill"},[_c('div',{staticClass:"description"},[_vm._v("抱歉，您无权限访问该页面")])])}]

export { render, staticRenderFns }